import { useSrpContext } from '@/src/contexts'
import { useSearchParams } from 'next/navigation'

export const useGetSearchParamsObj = (): { urlQueryObj: Record<string, string>; isSeoQuery: boolean } => {
    const {
        SEOSrpData: { searchQuery: seoQuery }
    } = useSrpContext()
    const searchParams = useSearchParams()
    const urlQueryObj = seoQuery
        ? (seoQuery as unknown as Record<string, string>)
        : Object.fromEntries(searchParams.entries())

    //temporary line
    // urlQueryObj.depart_date = '25/01/2026'

    return {
        urlQueryObj,
        isSeoQuery: !!seoQuery
    }
}
